import routes from 'js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';

export type BuildVuPage = {
  width: number;
  height: number;
  page_number: number;
  page_url: string;
  preload?: boolean;
};

export type Manifest = BuildVuPage[];

export const getManifest = async (
  attachmentId: string | number,
): Promise<Manifest> => {
  const response = await fetchWithCsrf(
    routes.api_v0_document_viewer_show_build_vu_page_defs_path({
      subdomain_param: 'api',
      attachment_id: attachmentId,
    }),
  );

  if (response.ok) {
    return response.json();
  } else {
    throw new Error('Failed to fetch manifest');
  }
};
